<template>
	<div class="modal">
		<div class="row">
			<div class="col-md-12 end-sm end-md end-lg">
				<a @click="close()"><span class="fa-light fa-circle-xmark textXlg textGrey"></span></a>
			</div>
		</div>
		<div class="row margin-b40">
			<div class="col-md-12">
				<p class="textGrey textLg textCenter">Numbers Assigned</p>
			</div>
		</div>
		<div class="row margin-b40">
			<div class="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3">
				<p class="textRed textCenter">
					Unable to delete LCR. The following numbers have this LCR currently in use and will need to be
					changed:
				</p>
			</div>
		</div>

		<div class="row margin-b50">
			<div class="col-xs-12 col-sm-12 col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3">
				<div class="card formPanel">
					<div class="content">
						<div class="col-xs-12">
							<div class="listHeader">
								<div class="row">
									<div class="col-xs-3 col-sm-2 col-md-2 col-lg-2">
										<p>Phone Number</p>
									</div>
								</div>
							</div>
						</div>
						<div class="row content middle-sm middle-md middle-lg">
							<div class="col-xs-12">
								<div
									v-for="phoneNumber in numbersAssigned"
									:key="phoneNumber.id"
									class="card listItem"
									@click="routeTo('/phonenumbers/' + phoneNumber.id)"
								>
									<div class="row">
										<div class="col-xs-12 mobileMargin-b20">
											<p>{{ phoneNumber.number }}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row margin-b20">
			<div class="col-md-12">
				<ul class="stepBtns">
					<li><a class="jmiBtn btnLg red" @click="close()">Close</a></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { router } from '../router'

export default {
	inject: ['user', 'userRoles', 'showNumbersAssignedModal'],
	props: ['numbersAssigned'],
	methods: {
		close() {
			this.showNumbersAssignedModal = false
		},
		routeTo(routeName) {
			router.push(routeName)
		}
	}
}
</script>
